module.exports = __webpack_public_path__ + "img/articleImage.ed23e3e8.png";